import { maintenanceModeAtom } from "../../../errorHandling/maintenanceMode";
import { useSetAtom } from "jotai";

import { JSX } from "react";

import { Button } from "@mui/material";

export default function DevMaintenanceModeButton(): JSX.Element | null {
  const setMaintenanceMode = useSetAtom(maintenanceModeAtom);

  return (
    <Button
      variant="contained"
      size="small"
      color="warning"
      onClick={() => setMaintenanceMode(true)}
    >
      Trigger maintenance mode
    </Button>
  );
}
